export default __webpack_public_path__ + "static/media/6.73a87ff7.svg";